import { TbFilter, TbFilterOff } from 'react-icons/tb';

import { Flex, Indicator, Menu } from '@mantine/core';

import { InlineFilters } from 'components/component-overview/inline-filters/InlineFilters';

const InlineFiltersMoreButton = ({
    showClearButton,
    onClear,
    MoreFilters,
}: {
    showClearButton?: boolean;
    onClear?: () => void;
    MoreFilters?: React.ReactNode;
}) => {
    return (
        <InlineFilters.Section
            body={
                <Indicator
                    disabled={!showClearButton}
                    color="red"
                    size={6}
                    styles={{
                        indicator: { top: 4, right: 2 },
                    }}
                >
                    <Flex mt={2}>
                        <TbFilter size={14} strokeWidth={1.5} />
                    </Flex>
                </Indicator>
            }
            popoverContent={
                <>
                    {showClearButton && (
                        <>
                            <Menu.Item
                                color="red"
                                onClick={onClear}
                                leftSection={<TbFilterOff size={14} strokeWidth={1.5} />}
                            >
                                Clear all filters
                            </Menu.Item>
                        </>
                    )}

                    {showClearButton && MoreFilters && <Menu.Divider />}

                    {MoreFilters}
                </>
            }
            active={false}
        />
    );
};

export { InlineFiltersMoreButton };
